import React from 'react';

function Grenada(props) {
  return (
    <svg
      {...props}
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_800_124126)">
        <mask
          id="mask0_800_124126"
             style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="36"
          height="24"
        >
          <rect width="36" height="24" fill="white" />
        </mask>
        <g mask="url(#mask0_800_124126)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H36V24H0V0Z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.75 6H29.25V18H6.75V6Z"
            fill="#FECA00"
          />
          <mask
            id="mask1_800_124126"
               style={{ maskType: 'luminance' }}
            maskUnits="userSpaceOnUse"
            x="6"
            y="6"
            width="24"
            height="12"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.75 6H29.25V18H6.75V6Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_800_124126)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6.75 6L18 12L6.75 18V6Z"
              fill="#23875F"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M29.25 6L18 12L29.25 18V6Z"
              fill="#23875F"
            />
            <mask
              id="mask2_800_124126"
                 style={{ maskType: 'luminance' }}
              maskUnits="userSpaceOnUse"
              x="18"
              y="6"
              width="12"
              height="12"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29.25 6L18 12L29.25 18V6Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask2_800_124126)" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18 16C20.4853 16 22.5 14.2091 22.5 12C22.5 9.79086 20.4853 8 18 8C15.5147 8 13.5 9.79086 13.5 12C13.5 14.2091 15.5147 16 18 16Z"
              fill="#C51918"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.9206 13.3133L15.5909 14.7497L16.3353 12.2894L14.625 10.7178L16.9408 10.6328L17.9206 8.20001L18.9004 10.6328H21.2123L19.506 12.2894L20.3606 14.6045L17.9206 13.3133Z"
              fill="#FECA00"
            />
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.87365 4.44203L11.1469 3.74023L12.4803 4.37109L12.0133 3.24002L12.9458 2.43065H11.6823L11.1469 1.24203L10.6114 2.43065L9.34581 2.47217L10.2805 3.24002L9.87365 4.44203ZM16.6237 4.44203L17.8969 3.74023L19.2303 4.37109L18.7633 3.24002L19.6958 2.43065H18.4323L17.8969 1.24203L17.3614 2.43065L16.0958 2.47217L17.0305 3.24002L16.6237 4.44203ZM24.6469 3.74023L23.3737 4.44203L23.7805 3.24002L22.8458 2.47217L24.1114 2.43065L24.6469 1.24203L25.1823 2.43065H26.4458L25.5133 3.24002L25.9803 4.37109L24.6469 3.74023ZM9.87257 22.1672L11.1458 21.4654L12.4792 22.0962L12.0122 20.9651L12.9447 20.1558H11.6813L11.1458 18.9672L10.6103 20.1558L9.34473 20.1973L10.2794 20.9651L9.87257 22.1672ZM17.8958 21.4654L16.6226 22.1672L17.0294 20.9651L16.0947 20.1973L17.3603 20.1558L17.8958 18.9672L18.4312 20.1558H19.6947L18.7622 20.9651L19.2292 22.0962L17.8958 21.4654ZM23.3726 22.1672L24.6458 21.4654L25.9792 22.0962L25.5122 20.9651L26.4447 20.1558H25.1812L24.6458 18.9672L24.1103 20.1558L22.8447 20.1973L23.7794 20.9651L23.3726 22.1672Z"
            fill="#FECA00"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.71398 12.772C9.71398 12.772 10.3199 13.2514 10.6498 13.4147C10.7636 13.0314 10.5098 12.1629 10.5098 12.1629C10.4385 11.9553 9.65722 11.5831 9.65722 11.5831C9.65722 11.5831 9.43777 12.2385 9.71398 12.772Z"
            fill="#C51918"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.3453 13.9302C10.3453 13.9302 8.78913 13.2841 8.63099 12.3703C8.47286 11.4565 8.80822 9.99976 8.80822 9.99976C8.80822 9.99976 11.3352 10.5109 11.5071 11.6061C11.6791 12.7013 11.1083 13.3894 11.1083 13.3894C11.1083 13.3894 10.5238 12.0543 9.97224 11.9062C9.97224 11.9062 9.97224 13.2293 10.3453 13.9302Z"
            fill="#FECA00"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_800_124126">
          <rect width="36" height="24" rx="5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Grenada;
